@if (!editMode) {
  <h2 mat-dialog-title>Datenquelle hinzufügen</h2>
}
@if (editMode) {
  <h2 mat-dialog-title>Datenquelle editieren</h2>
}
<mat-dialog-content>
  <div>
    <form
      [formGroup]="datasourceForm"
      (ngSubmit)="updateOrCreateDatasource()"
      ngNativeValidate
      class="d-flex flex-column"
      >
      <mat-form-field>
        <mat-label>Name der Datenquelle</mat-label>
        <input matInput formControlName="name" required />
        @if (datasourceForm.controls.name.hasError('required')) {
          <mat-error
            >Feld wird benötigt</mat-error
            >
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Name der Tabelle</mat-label>
          <input matInput formControlName="table_name" required />
          @if (datasourceForm.controls.table_name.hasError('required')) {
            <mat-error
              >Feld wird benötigt</mat-error
              >
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>Auftraggeber</mat-label>
            <mat-select formControlName="assigned_client" required>
              @for (client of availableClients; track client) {
                <mat-option
                  matInput
                  [value]="client.id"
                  >{{ client.name }}</mat-option
                  >
                }
              </mat-select>
            </mat-form-field>

            <button
              mat-raised-button
              color="primary"
              type="submit"
              [disabled]="!datasourceForm.valid"
              >
              @if (editMode) {
                Speichern
              }
              @if (!editMode) {
                Hinzufügen
              }
            </button>
          </form>
        </div>
      </mat-dialog-content>
